import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

type ModalInputProps = React.InputHTMLAttributes<HTMLInputElement>

const ModalInput: React.FC<ModalInputProps> = ({ className, ...props }) => {
  const classes = useStyles()

  return <input className={clsx(classes.root, className)} {...props} />
}

export default ModalInput
